import { ViewChild, Renderer, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { IChangeCallback } from '../../_entities';
import { PopoverEditable } from './popover-editable'

export abstract class PopoverEditableDropDownComponentBase<T> extends PopoverEditable {

    constructor(protected renderer: Renderer, protected element: ElementRef) {
        super(renderer, element);
    }
  
    private _originalValue: T;
    private _originalSelectedValue: T;

    ngOnInit() {
        this.updateItemList();
    }

    @Input() placement: string = "top";

    @ViewChild('focustarget') inputElementRef;

    @ViewChild('pop') popoverElementRef;

    @Input() name: string = "(Unnamed)";

    @Input() disabled: boolean = false;

    onSave() {
        if (this.hasUnsavedChanges) {
            this.saving = true;
            this.errorMessage = null;
            this.changeCallback.emit({
                id: this.id,
                newValue: this.selectedItem,
                oldValue: this._originalValue,
                resolve: () => {
                    this._originalValue = this.selectedItem;
                    this._originalSelectedValue = this.selectedItem;
                    this.saving = false;

                    this.hasUnsavedChanges = false;
                    this.hide();
                }
                ,
                reject: (message: string) => {
                    this.saving = false;
                    this.errorMessage = message;
                }
            });
        } else {
            this.onCancel();
        }
    }

    onCancel() {
        this.selectedItem = this._originalSelectedValue;
        this.hasUnsavedChanges = false;
        this.errorMessage = null;
        this.hide();
    }

    onChange() {
        this.errorMessage = null;
        this.hasUnsavedChanges = this.selectedItem !== this._originalSelectedValue;
    }

    getText(itemToFind: T): string {
        return this.getDisplayValue(itemToFind);
    }

    getDescription(itemToFind: T): string {
        const item = this.getValue(itemToFind);
        return item != null && item.hasOwnProperty("description") ? item["description"] : null;
    }

    protected updateItemList() {
        this.items = null;
        this.isLoadingItems = true;
        this.getItems().then(items => {
            this.items = items;
            this.selectedItem = this.selectedItem ? this.mapItem(this.items, this.selectedItem) : null;
            this._originalSelectedValue = this.selectedItem;
            this.isLoadingItems = false;
        });
    }
    protected abstract getItems(): Promise<T[]>;

    protected abstract mapItem(items: T[], item: T): T;

    protected abstract getDisplayValue(item: T);

    protected abstract getValue(itemToFind: T): any;

    protected onItemSelected(item: T) {
        if (this.items) {
            this.selectedItem = item != null ? this.mapItem(this.items, item) : null;
        } else {
            this.selectedItem = item;
        }
        this._originalValue = item;
    }

    @Input() id: string;

    @Input('selectedItem') set selectedItemValue(val: T) { this.onItemSelected(val); }

    @Output() changeCallback = new EventEmitter<IChangeCallback<T>>();

    @Input('allowEmpty') set setAllowEmpty(val: any) {
        //console.log("Allow Empty", typeof val);
        if (typeof val === 'string') {
            this.allowEmpty = val.toLowerCase() === 'true';
            return;
        }
        this.allowEmpty = val;
    }

    @Input() placeholder: string;

    get originalValueDisplayValue() {
        return this.getText(this._originalValue) || (this.allowEmpty ? " - " : null);
    }

    items: T[];
    selectedItem: T;
    isLoadingItems: boolean;
    nullValue = null;
    errorMessage: string;
 
    hasUnsavedChanges: boolean;
    allowEmpty = false;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/popover-editable-dropdown.base.component.ts